export default "__VITE_ASSET__bb46a4ff__"